import splitClassTokens from '../../breakpoint-editing/helpers/split-class-tokens';
import parsePrefixedClassToken from '../../breakpoint-editing/helpers/parse-prefixed-class-token';
import buildPrefixedClassToken from '../../breakpoint-editing/helpers/build-prefixed-class-token';
import breakpoints, { breakpointKeyByPrefix, breakpointKeys } from '../constants/breakpoints';
import { findTargetForToken } from './handle-class-token';

// Breakpoints outside the cascade are not editable here, so their tokens stay as they are.
const resolveBreakpointKey = (prefix) =>
  prefix ? breakpointKeyByPrefix[prefix] : breakpointKeys.DEFAULT;

const parseBodiesByBreakpointKeyByTarget = (newClass, targets) =>
  splitClassTokens(newClass).reduce((bodiesByBreakpointKeyByTarget, classToken) => {
    const { prefix, token } = parsePrefixedClassToken(classToken);
    const breakpointKey = resolveBreakpointKey(prefix);
    const target = breakpointKey ? findTargetForToken(token, targets) : null;

    if (!target) return bodiesByBreakpointKeyByTarget;

    return {
      ...bodiesByBreakpointKeyByTarget,
      [target]: {
        ...bodiesByBreakpointKeyByTarget[target],
        [breakpointKey]: token,
      },
    };
  }, {});

const buildTargetTokens = (bodiesByBreakpointKey) => {
  const tokens = [];

  breakpoints.forEach(({ key, prefix }) => {
    const body = bodiesByBreakpointKey[key];

    if (body === undefined) return;

    tokens.push(buildPrefixedClassToken(body, prefix));
  });

  return tokens.reverse();
};

const normalizeResponsiveClasses = ({ targets = [], currentClass = '', newClass = '' }) => {
  const bodiesByBreakpointKeyByTarget = parseBodiesByBreakpointKeyByTarget(newClass, targets);

  const preservedTokens = splitClassTokens(currentClass).filter((classToken) => {
    const { prefix, token } = parsePrefixedClassToken(classToken);

    if (!resolveBreakpointKey(prefix)) return true;

    return !findTargetForToken(token, targets);
  });

  const normalizedTokens = targets.flatMap((target) =>
    buildTargetTokens(bodiesByBreakpointKeyByTarget[target] || {})
  );

  return [...preservedTokens, ...normalizedTokens].join(' ');
};

export default normalizeResponsiveClasses;
